__turbopack_context__.v({
  "time": "relative-time-module__OEAtmq__time",
});
